/**
 * Documentation link of RPC methods
 */
const RPC_DOCUMENTATION_URL =
    'https://ethereum.github.io/execution-apis/api-documentation/';

export { RPC_DOCUMENTATION_URL };
